import { IS_LOADING } from '../actions/action_types';
import { console_log } from "../utils/helper";

const initialState = {
    isLoading: false
};

export const ActivityIndicatorReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case IS_LOADING:
            return {
                isLoading: action.data.isLoading
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/ActivityIndicatorReducer.js